import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";


// MUI imports
import Grid from "@mui/material/Grid";

// Project Imports
import TextFieldPA from "./UI/TextFieldPA";
import FormSubmitButton from "./UI/FormSubmitButton";
import ApprovalGroup from "./UI/ApprovalGroup";

import { paNextFormStep } from "../../Actions"

const formValidationSchema = Yup.object().shape({
  isTrainingTypes: Yup.boolean().required("This is a required field"),
  isSkillCenterName: Yup.boolean().required("This is a required field"),
  isCenterEmail: Yup.boolean().required("This is a required field"),
  isCenterPhoneNumber: Yup.boolean().required("This is a required field"),
  isCenterWhatsappNumber: Yup.boolean().required("This is a required field"),
  isPhysicalAddress: Yup.boolean().required("This is a required field"),
  isCloseLandMark: Yup.boolean().required("This is a required field"),
  isSkills: Yup.boolean().required("This is a required field"),
  isStateId: Yup.boolean().required("This is a required field"),
  isLocalGovernment: Yup.boolean().required("This is a required field"),
  
});

const formState = {
  isTrainingTypes: null,
  isSkillCenterName: null,
  isCenterEmail: null,
  isCenterPhoneNumber: null,
  isCenterWhatsappNumber: null,
  isPhysicalAddress: null,
  isCloseLandMark: null,
  isSkills: null,
  isStateId: null,
  isLocalGovernment: null
};

const PartOne = () => {
  const globalDispatch = useDispatch();
  const tregPhysicalApprovalReducer = (globalState) =>
    globalState.tregPhysicalApprovalReducer;

  const { singleTrainerDetails } = useSelector(tregPhysicalApprovalReducer);

  const sectionsOneToTwoMarkup = [
    {
      name: "isTrainingTypes",
      value: singleTrainerDetails?.trainingType?.trainingName,
      label:
        "What type of training is carried out in your centre? (Select one)*",
    },
    {
      label: "List the skills taught in your centre*",
      name: "isSkills",
      value: singleTrainerDetails?.skills,
    },
  ];
  
  const sectionThreeMarkup = [
    [
      {
        label: "Name of Centre*",
        name: "isSkillCenterName",
        value: singleTrainerDetails?.skillCenterName,
      },
      {
        label: "Centre Email Address*",
        name: "isCenterEmail",
        value: singleTrainerDetails?.centerEmail,
      },
    ],
    [
      {
        label: "Phone Number*",
        name: "isCenterPhoneNumber",
        value: singleTrainerDetails?.centerPhoneNumber,
      },
      {
        label: "WhatsApp Number*",
        name: "isCenterWhatsappNumber",
        value: singleTrainerDetails?.centerWhatsappNumber,
      },
    ],
    [
      {
        label: "State*",
        name: "isStateId",
        value: singleTrainerDetails?.state,
      },
      {
        name: "isLocalGovernment",
        label: "L.G.A*",
        value: singleTrainerDetails?.lga,
      },
    ],
    [
      {
        label: "Full Address*",
        name: "isPhysicalAddress",
        value: singleTrainerDetails?.physicalAddress,
      },
      {
        label: "Landmark(s) closest to you*",
        name: "isCloseLandMark",
        value: singleTrainerDetails?.closeLandMark,
      },
    ],
  ];

  const handleStepSubmit = (values) => {
    globalDispatch(paNextFormStep(values))
  };

  return (
    <Formik
      initialValues={{
        ...formState,
      }}
      validationSchema={formValidationSchema}
      onSubmit={handleStepSubmit}
    >
      <Form>
        <h2>Section 1 </h2>
        {sectionsOneToTwoMarkup.map((field) => (
          <Grid item xs key={field.label}>
            <TextFieldPA
              label={field.label}
              value={field.value}
            />
            <ApprovalGroup fieldName={field.name} />
          </Grid>
        ))}

        {sectionThreeMarkup.map((row, index) => (
          <Grid
            key={index}
            sx={{
              display: "flex",
              flexDirection: "row",
            }}
            container
            spacing={3}
          >
            {row.map((field, index) => (
              <Grid item xs={12} md={6} key={index}>
                <TextFieldPA
                  label={field.label}
                  value={field.value}
                />
                <ApprovalGroup fieldName={field.name}/>
              </Grid>
            ))}
          </Grid>
        ))}
        <Grid
          item
          xs
          container
          sx={{ justifyContent: "flex-end", paddingTop: "1rem" }}
        >
          <FormSubmitButton sx={{ width: "fit-content" }}> 
            Next 
          </FormSubmitButton>
        </Grid>
      </Form>
    </Formik>
  );
};

export default PartOne;
